import React, { useState } from "react";
import styled from "styled-components";
import {
  PrimaryOutlinedCTAButton,
  PrimaryCTAButton as PrimaryButton,
} from "../../../common/CustomButtons";
import { navigate } from "@reach/router";
import { Images } from "../../../../assets/images";
import { H2 } from "../../AboutUs/Styles";

const ODRInsightsComponent = ({
  CommercialDisputes,
  FamilyDisputes,
  JustActMailers,
}) => {
  const [visibleCards, setVisibleCards] = useState(3);

  const insights = [
    {
      date: "21 AUG",
      year: "2022",
      title: "Mediation in Commercial Disputes",
      description:
        "The Commercial Courts Act, 2015 was enacted by the Parliament in order to facilitate ease of doing business and encourage foreign capital and investment in the country.",
      icon: CommercialDisputes,
      link: "/blog/commercial-disputes",
    },
    {
      date: "18 Nov",
      year: "2022",
      title: "Mediation in Family Matters",
      description:
        "Interpersonal and professional relationships oriented towards the long term are prone to conflict and rupture",
      icon: FamilyDisputes,
      link: "/blog/mediation-in-family",
    },
    {
      date: "2 APR",
      year: "2022",
      title: "Experts as Arbitrators",
      description:
        "In a fast-paced world where disputes between private parties are gaining in complexity and value, the need for experts as arbitrators has increased greatly",
      icon: JustActMailers,
      link: "/blog/experts-as-arbitrators",
    },
  ];

  const stats = [
    { number: "74,000+", label: "Cases handled" },
    { number: "65,000+", label: "Arbitrations" },
    { number: "140+", label: "Mediations" },
    { number: "9,400+", label: "Hours of Legal & Court-room transcriptions" },
  ];

  const benefits = [
    {
      title: "Faster Resolution",
      description: "Efficient and quicker TAT inline with Arbitration Act",
      icon: Images.FasterResolution,
    },
    {
      title: "Affordable",
      description: "Cost-efficient and budget-friendly",
      icon: Images.SignificantCost,
    },
    {
      title: "Scalable",
      description: "Platform processes bulk disputes simultaneously",
      icon: Images.Scalability,
    },
    {
      title: "Accessible from Anywhere",
      description: "File disputes, anytime, from anywhere",
      icon: Images.RemoteAccess,
    },
    {
      title: "Legally Sound Outcomes",
      description: "In compliance with Arbitration & Conciliation Act",
      icon: Images.LegallySound,
    },
    {
      title: "Neutral & Confidential",
      description: "Impartial, Fair & Independent Platform",
      icon: Images.ClientNeutral,
    },
  ];

  const handleViewMore = () => {
    setVisibleCards((prev) => Math.min(prev + 3, insights.length));
  };

  return (
    <Container>
      <Header>
        <H2 style={{ textAlign: "center" }}>Insights from the World of ODR</H2>
      </Header>

      <InsightsGrid>
        {insights.slice(0, visibleCards).map((insight, index) => (
          <InsightCard key={index}>
            {/* <CardHeaderImage bgImage={insight.icon} /> */}
            <ContentWrapper>
              <CardDate>
                <DateItem>
                  <IconSvg bgImage={Images.IconFrame} />
                  <DateText>Admin</DateText>
                </DateItem>
                <DateItem>
                  <IconSvg bgImage={Images.IconDate} />
                  <DateText>
                    {insight.date}, {insight.year}
                  </DateText>
                </DateItem>
              </CardDate>

              <CardTitle>{insight.title}</CardTitle>
              <CardDescription>{insight.description}</CardDescription>
            </ContentWrapper>

            <div
              style={{
                marginBottom: "30px",
                width: "auto",
                marginLeft: "20px",
                marginRight: "20px",
              }}
            >
              <PrimaryButton onClick={() => navigate(insight.link)}>
                Read More
              </PrimaryButton>
            </div>
          </InsightCard>
        ))}
      </InsightsGrid>

      <ButtonRow>
        <PrimaryOutlinedCTAButton
          style={{ width: "auto" }}
          onClick={() => navigate("/resources/blogs")}
        >
          View All Blogs
        </PrimaryOutlinedCTAButton>
      </ButtonRow>

      {visibleCards < insights.length && (
        <ViewMoreContainer>
          <ViewMoreButton onClick={handleViewMore}>
            View More Insights
          </ViewMoreButton>
        </ViewMoreContainer>
      )}

      <StatsSection>
        <StatsGrid>
          {stats.map((stat, index) => (
            <StatCard key={index}>
              <StatNumber>{stat.number}</StatNumber>
              <StatLabel>{stat.label}</StatLabel>
            </StatCard>
          ))}
        </StatsGrid>
      </StatsSection>

      <BenefitsSection>
        <H2 style={{ textAlign: "center", marginBottom: "10px" }}>
          Benefits of Choosing IAMC 
        </H2>
        <BenefitsGrid>
          {benefits.map((benefit, index) => (
            <BenefitCard key={index}>
              <BenefitIcon bgImage={benefit.icon} />
              <BenefitTitle>{benefit.title}</BenefitTitle>
              <BenefitDescription>{benefit.description}</BenefitDescription>
            </BenefitCard>
          ))}
        </BenefitsGrid>
      </BenefitsSection>
    </Container>
  );
};

export default ODRInsightsComponent;

export const Container = styled.div`
  width: 100%;
  background: #ffffff;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  // padding: 4rem 0;
`;

export const Header = styled.div`
  text-align: center;
  margin-bottom: 3rem;
`;

export const InsightsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 2rem;
  max-width: 1400px;
  margin: 0 auto 4rem;
  padding: 0 2rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    padding: 0 1rem;
    gap: 1.5rem;
  }
`;

export const InsightCard = styled.div`
  background: white;
  border-radius: 15px;
  overflow: hidden;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  border: 2px solid transparent;
  display: flex;
  flex-direction: column;

  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.15);
  }
`;

export const CardHeaderImage = styled.div`
  width: 100%;
  height: 220px;
  background: ${(props) => `url(${props.bgImage})`} center/cover no-repeat;
  border-radius: 12px 12px 0 0;

  @media (max-width: 768px) {
    height: 200px;
  }

  @media (max-width: 480px) {
    height: 180px;
  }
`;

export const ContentWrapper = styled.div`
  padding: 1.5rem;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
`;

export const CardDate = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 1rem;
  flex-wrap: wrap;
  gap: 1rem;
`;

export const DateItem = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const IconSvg = styled.div`
  width: 20px;
  height: 20px;
  background: ${(props) => `url(${props.bgImage})`} center/cover no-repeat;
`;

export const DateText = styled.span`
  font-size: 0.9rem;
  color: #293461;
`;

export const CardTitle = styled.h3`
  font-size: 1.2rem;
  font-weight: 600;
  color: #293461;
  margin: 0 0 1rem 0;
  line-height: 1.4;
`;

export const CardDescription = styled.p`
  font-size: 1rem;
  color: #293461;
  line-height: 1.6;
  margin-bottom: 1.5rem;
  flex-grow: 1;
`;

export const ButtonRow = styled.div`
  text-align: center;
  margin: 2rem 0;
`;

export const ViewMoreContainer = styled.div`
  text-align: center;
  margin: 3rem 0;
`;

export const ViewMoreButton = styled.button`
  background: transparent;
  color: #00818a;
  border: 2px solid #00818a;
  border-radius: 30px;
  padding: 0.9rem 2.5rem;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: #00818a;
    color: white;
    transform: scale(1.05);
  }
`;

export const StatsSection = styled.div`
  background: #e6f3f4;
  border-radius: 20px;
  padding: 4rem 2rem;
  margin: 4rem 2rem;

  @media (max-width: 768px) {
    margin: 3rem 1rem;
    padding: 3rem 1.5rem;
  }
`;

export const StatsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 2rem;
  text-align: center;
`;

export const StatCard = styled.div`
  padding: 1rem;
`;

export const StatNumber = styled.div`
  font-size: clamp(2.5rem, 5vw, 3.5rem);
  font-family: openSans-SemiBold, sans-serif;
  color: #00818a;
`;

export const StatLabel = styled.div`
  font-size: 1.1rem;
  color: #293461;
  margin-top: 0.5rem;
  font-weight: 600;
`;

export const BenefitsSection = styled.div`
  text-align: center;

  @media (max-width: 768px) {
    padding: 3rem 1rem;
  }
`;

export const BenefitsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  max-width: 1200px;
  margin: 3rem auto 0;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const BenefitTitle = styled.h4`
  font-size: 1.2rem;
  font-family: openSans-SemiBold, sans-serif;
  color: #293461;
  margin-bottom: 1rem;
  transition: color 0.3s ease;
`;

export const BenefitDescription = styled.p`
  font-size: 0.95rem;
  color: #293461;
  line-height: 1.5;
  transition: color 0.3s ease;
`;

export const BenefitCard = styled.div`
  background: white;
  border-radius: 15px;
  padding: 2.5rem 1.5rem;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.08);
  border: 2px solid transparent;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.12);
    border-color: #00818a;
    background: #00818a;
    color: white;

    ${BenefitTitle}, ${BenefitDescription} {
      color: white;
    }
  }
`;

export const BenefitIcon = styled.div`
  width: 70px;
  height: 70px;
  background: ${(props) => `url(${props.bgImage})`} center/contain no-repeat;
  margin: 0 auto 1.5rem;
  transition: transform 0.3s ease;

  ${BenefitCard}:hover & {
    transform: scale(1.15);
  }
`;
